import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SHORTCUTS = [
  { key: 'g d', label: 'Go to Dashboard',    path: '/dashboard' },
  { key: 'g p', label: 'Go to Projects',     path: '/projects' },
  { key: 'g t', label: 'Go to Tasks',        path: '/tasks' },
  { key: 'g n', label: 'Go to Notifications',path: '/notifications' },
  { key: 'g c', label: 'Go to Calendar',     path: '/calendar' },
  { key: 'g i', label: 'Go to Invoices',     path: '/invoices' },
  { key: 'g e', label: 'Go to Expenses',     path: '/expenses' },
  { key: 'g a', label: 'Go to Analytics',    path: '/analytics' },
  { key: '?',   label: 'Show shortcuts',     path: null },
];

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [seq, setSeq] = useState('');

  useEffect(() => {
    let timer;
    const handler = (e) => {
      const tag = e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || e.target.isContentEditable) return;

      if (e.key === '?') { setShowModal(m => !m); return; }
      if (e.key === 'Escape') { setShowModal(false); setSeq(''); return; }

      const next = seq ? seq + ' ' + e.key : e.key;
      setSeq(next);
      clearTimeout(timer);
      timer = setTimeout(() => setSeq(''), 1500);

      const match = SHORTCUTS.find(s => s.key === next && s.path);
      if (match) { navigate(match.path); setSeq(''); clearTimeout(timer); }
    };
    window.addEventListener('keydown', handler);
    return () => { window.removeEventListener('keydown', handler); clearTimeout(timer); };
  }, [seq, navigate]);

  return { showModal, setShowModal, SHORTCUTS };
}
